// NEW: UI_REVAMP
import { Button, Flex } from '@chakra-ui/react';
import { RECORD_GRADIENTS } from '../../styles/recordUiTokens';

const GoldPatternButton = ({ children, onClick, isDisabled, ...props }) => {
	const baseBg =
		'radial-gradient(ellipse 75px 5px at 50% 0%, rgba(243, 108, 24, 0.6), transparent), radial-gradient(ellipse 75px 5px at 50% 100%, rgba(243, 108, 24, 0.6), transparent), linear-gradient(180deg, #FECC18 0%, #FEA338 25%, #FEA338 75%, #FECC18 100%), lightgray';

	return (
		<Button
			position='relative'
			bgGradient={RECORD_GRADIENTS.goldBorder}
			w='full'
			h={{ base: '52px', lg: '56px' }}
			onClick={() => {
				if (isDisabled) return;
				onClick();
			}}
			overflow='hidden'
			p={0.5}
			borderRadius='full'
			_hover={{
				bgGradient: RECORD_GRADIENTS.goldBorder,
			}}
			_active={{
				bgGradient: RECORD_GRADIENTS.goldBorder,
			}}
			color={isDisabled ? 'rgba(233, 127, 21, 1)' : 'white'}
			fontSize='18px'
			fontWeight={600}
			{...props}
		>
			<Flex
				justifyContent='center'
				alignItems='center'
				gap={2}
				w='full'
				h='full'
				borderRadius='full'
				bg={`url("/assets/img/gold-pattern-bg.png") no-repeat center / 115% 125%, ${baseBg}`}
				boxShadow='0 0 6.207px 0 #AD6F12'
				px='14px'
				color='inherit'
				cursor={isDisabled ? 'not-allowed' : 'pointer'}
			>
				{children}
			</Flex>
		</Button>
	);
};

export default GoldPatternButton;
